import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import SearchBox from 'components/common/SearchBox';
import PersonasTable, { PersonasTableColumns } from 'components/tables/PersonasTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useState, useEffect, ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Persona } from 'data/crm/Personas'; // Importa tu interfaz aquí
import { useNavigate } from 'react-router-dom';

const Personas = () => {
  const [personas, setPersonas] = useState<Persona[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000';


  useEffect(() => {
    fetch(`${apiUrl}/personas`) // Asegúrate de ajustar la URL si usas un archivo de config base (ej: http://localhost:3000/personas)
      .then((res) => {
        if (!res.ok) throw new Error('Error al cargar personas');
        return res.json();
      })
      .then((data: Persona[]) => {
        setPersonas(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const table = useAdvanceTable({
    data: personas, // Enviamos el estado dinámico en vez de leadsTableData
    columns: PersonasTableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false, 
    initialState: {
      sorting: [] // 👈 Al dejarlo vacío, respeta el orden natural del JSON (el del backend)
    }
  });

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  if (loading) {
    return <div className="p-6 text-center">Cargando listado de personas...</div>;
  }


{/* <PageBreadcrumb items={defaultBreadcrumbItems} />
 */}  

  return (
    <div>   
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <h2 className="mb-4">Personas</h2>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <Button
                variant="primary"
                className="me-4"
                startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                onClick={() => navigate('/app/apps/crm/agregar-persona')}
              >
                Agregar Persona
              </Button>
            </Col>
            <Col xs="auto">
              <div className="d-flex">
                <SearchBox
                  placeholder="Buscar personas..."
                  className="me-2"
                  onChange={handleSearchInputChange}
                />
              </div>
            </Col>
          </Row>
          <PersonasTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default Personas;